package app.nestbridge.app.di

import app.nestbridge.config.BuildKonfig
import com.karawek.core.auth.stytch.config.StytchConfig
import com.karawek.core.auth.stytch.di.UseLocalAuthenticator
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesTo
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@ContributesTo(AppScope::class)
interface  StytchConfigModule {

    @SingleIn(AppScope::class)
    @Provides
    fun provideStytchConfig(): StytchConfig =
        StytchConfig(
            publicToken = BuildKonfig.stytchPublicToken,
            tokenExpirationMinutes = BuildKonfig.stytchTokenExpirationMinutes,
            sessionDurationMinutes = BuildKonfig.stytchSessionDurationMinutes,
            googleClientId = BuildKonfig.googleClientId,
            applicationId = BuildKonfig.applicationId,
            oauthCallbackPort = BuildKonfig.stytchOauthCallbackPort,
            passkeyDomain = BuildKonfig.passkeyDomain,
        )

    @SingleIn(AppScope::class)
    @Provides
    @UseLocalAuthenticator
    fun provideUseLocalAuthenticator(): Boolean = BuildKonfig.useLocalAuthenticator
}
